import {
  HandlersOrganizationTypeResponse,
  useDeleteApiOrganizationsTypesByOrganizationTypeMutation,
  useGetApiOrganizationsTypesQuery,
  usePatchApiOrganizationsTypesByOrganizationTypeMutation,
  usePostApiOrganizationsTypesMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

// OrganizationType uses the shared SimpleCatalog request shape.
const AdminOrganizationTypesPanel = () => (
  <AdminCatalogPanel<HandlersOrganizationTypeResponse>
    tableName="Organization Type"
    apiPath="/api/organizations/types"
    pkAccessor="organizationType"
    useList={() => useGetApiOrganizationsTypesQuery()}
    useCreate={usePostApiOrganizationsTypesMutation}
    useUpdate={usePatchApiOrganizationsTypesByOrganizationTypeMutation}
    useDelete={useDeleteApiOrganizationsTypesByOrganizationTypeMutation}
    buildCreateArg={(v) => ({
      handlersSimpleCatalogRequest: {
        name: (v.organizationType as string) ?? '',
        description: v.description as string | undefined,
      },
    })}
    buildUpdateArg={(row, v) => ({
      organizationType: row.organizationType as string,
      handlersSimpleCatalogUpdateRequest: {
        description: v.description as string | undefined,
      },
    })}
    buildDeleteArg={(row) => ({
      organizationType: row.organizationType as string,
    })}
    fields={[
      {
        name: 'organizationType',
        label: 'Organization Type',
        type: 'text',
        required: true,
        immutableOnEdit: true,
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="Organizations still reference this type. Reassign or remove them before deleting."
  />
);

export default AdminOrganizationTypesPanel;
